// THE AOTC TOOLTIPS ON THE EXPENSES LIST (ZEN-833). They used to say a
// set-aside expense is "paid out of pocket, not drawn from the 529" — false
// since the third answer: the 529 can pay the rest of the same expense. Never
// the same dollar (ZEN-164). Approved by Maryse, 31 Oct 2026, in the ZEN-833
// lane session ("Approve all"). The AOTC total's tag carries no hover text of
// its own: its information icon explains it (her ruling, same day).

// On the AOTC tag beside an expense, in the list and on a phone.
export const AOTC_ROW_TIP =
  "Part or all of this expense is reserved for the AOTC. The 529 cannot also pay for the reserved part.";
// The information icon beside the AOTC total.
export const aotcTotalInfo = (year) =>
  `Total reserved for the AOTC on ${year} expenses. ` +
  "A reserved dollar cannot also be paid from the 529, because the same dollar cannot count for both. " +
  "When only part of an expense is reserved, the 529 can still pay the rest of that expense. " +
  "This total matches the AOTC reserve on the Overview.";
